var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane active",attrs:{"id":"form-step-3"}},[_c('div',{staticClass:"row"},[(!_vm.showGBG)?[_c('div',{staticClass:"col-sm-12"},[_c('datetime-picker',{on:{"goNext":_vm.goNextStep}})],1)]:[_c('Identity')],(_vm.loading)?_c('Loading'):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }